import React from 'react';
import { Controller, Path, useFormContext } from 'react-hook-form';
import { useAccountFormContext } from '../../context/useAccountFormContext';
import { Select } from '../../../../../../../../CommonComponents/OPL/Select/Select/Select';
import { FormFields } from '../../AccountForm.meta';
import { TaxStatusDTO } from '../../../../../../api/useAccountsQuery';
import { EXCLUDE_FROM_ASSET_BUCKETING_OPTION_VALUE } from '../AssetBucketing/AssetBucketing.meta';

export const ManagementStyle = () => {
  const {
    options: { ManagementStyles, AssetBucketingByManagementStyle, AccountTypeOptions },
  } = useAccountFormContext();

  const { watch, control, setValue } = useFormContext<FormFields>();

  const [isOrion, accountType] = watch(['bankAccount.IsOrion', 'bankAccount.AccountType']);

  if (!AssetBucketingByManagementStyle && !isOrion) {
    return null;
  }

  const options = ManagementStyles.map(({ name, id, defaultBucket }) => ({
    value: id,
    label: name,
    defaultBucket,
  }));

  const accountTypeOption = AccountTypeOptions.find(option => option.AccountType === accountType);

  const taxStatusOptions = accountTypeOption?.BalanceTaxStatuses || [];

  return (
    <Controller
      control={control}
      name="bankAccount.OrionManagementStyleId"
      render={({ field: { value, onChange, disabled } }) => {
        return (
          <Select
            isPortal
            value={options.find(option => option.value === value) ?? null}
            options={options}
            onChange={option => {
              onChange(option?.value ?? null);

              if (option) {
                const defaultBucket =
                  option.defaultBucket === null
                    ? EXCLUDE_FROM_ASSET_BUCKETING_OPTION_VALUE
                    : option.defaultBucket;

                if (taxStatusOptions.length > 0) {
                  taxStatusOptions
                    .filter(({ Value }) => Value !== TaxStatusDTO.Mix)
                    .forEach(({ Value }) => {
                      const key = TaxStatusDTO[Value];

                      const formPath = `bankAccount.Balances.${key}.AssetBucketIndex` as Path<
                        FormFields
                      >;

                      setValue(formPath, defaultBucket);
                    });
                }

                setValue('bankAccount.CustomAssetBucketIndex', defaultBucket);
              }
            }}
            label="Management Style"
            disabled={disabled || isOrion}
          />
        );
      }}
    />
  );
};
